// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "searchFlights__leg-oCB5w";
var _3 = "createRequest__row-2JQ-k";
export { _1 as "__esModule", _2 as "searchFlights__leg", _3 as "createRequest__row" }
export default { "__esModule": _1, "searchFlights__leg": _2, "createRequest__row": _3 }
